export default __webpack_public_path__ + "ca2b03fd58938a3d34e5b2b75c7501f8.jpg";